import { formatBytes } from "client/utils/formatBytes";
import { Size } from "store/types/previewImage";

export const calculateSpeed = (seconds: number, progress: number, fileSize: number) => {
    const bytesUploaded = (Number(progress) * fileSize) / 100;
    const result = formatBytes(bytesUploaded / seconds);
    return `${Math.round(Number(result.split(" ")[0]))} ${result.split(" ")[1]}` as Size;
};
